import React from 'react';
import PropTypes from 'prop-types';
import {
  SelectContainer,
  Select,
  ErrorText,
  SelectWrapper,
} from './styledComponents';

/**
 * RyderSelect Component documentation
 * @property       {string} name Selects's name
 * @property       {string} errorText Error text that will display if needed
 * @property       {bool} required Indicate if the select is required or not
 * @property       {func} onChange Function to handle onChange event
 *
 */

function RyderSelect(props) {
  const {
    name,
    required,
    onChange,
    errorText,
    children,
  } = props;
  const onChangeHandler = (event) => {
    const text = event.target.value;
    onChange(text, name);
  };
  return (
    <SelectContainer>
      <SelectWrapper>
        <Select
          name={name}
          required={required}
          onChange={onChangeHandler}
        >
          {children}
        </Select>
        <div className="arrow"></div>
      </SelectWrapper>
      { errorText !== '' && <ErrorText>{errorText}</ErrorText>}
    </SelectContainer>
  );
}

RyderSelect.propTypes = {
  name: PropTypes.string,
  required: PropTypes.bool,
  errorText: PropTypes.string,
};

RyderSelect.defaultProps = {
  required: false,
  errorText: '',
};

export default RyderSelect;



// WEBPACK FOOTER //
// ./src/components/RyderSelect/index.js